import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSignal = signal(false);
  
  constructor(
    private router: Router,
    private sharedService: SharedService
  ) {
    this.checkAuthenticationStatus();
  }

  private checkAuthenticationStatus() {
    // Check if user has a valid token
    const token = this.getToken();
    if (token) {
      this.isAuthenticatedSignal.set(true);
    }
  }

  login() {
    // This would typically redirect to your SSO login
    // For now, we'll just set authenticated to true for local development
    if (window.location.href?.includes('localhost')) {
      this.isAuthenticatedSignal.set(true);
    }
  }

  logout() {
    this.isAuthenticatedSignal.set(false);
    // Clear any stored tokens
    this.sharedService.deleteCookie('token');
    this.sharedService.deleteCookie('id_token');
    this.router.navigate(['/']);
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  getToken(): string {
    // Get token from cookies or localStorage
    return this.sharedService.getCookie('token') || this.sharedService.getCookie('id_token') || '';
  }

  getUserInfo() {
    // Return user info from shared service
    return this.sharedService.loggedInUser;
  }

  // Signals API usage
  get isAuthenticated$() {
    return this.isAuthenticatedSignal.asReadonly();
  }
}
